import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as TabsPrimitive from '@radix-ui/react-tabs';
import React from 'react';
import styled from 'styled-components';
import { TabBorder } from './tab-border';
export { Tabs, TabsList, TabsTrigger, TabsContent };
const TabsList = ({ ref, ...props }) => _jsx(TabsListWrapper, { ...props, ref: ref });
const TabsTrigger = ({ label, icon, ref, ...props }) => (_jsxs(Root, { ref: ref, ...props, children: [_jsxs(TabsTriggerValue, { children: [icon && React.cloneElement(icon, { size: 24 }), _jsx(TabsTriggerLabel, { children: label })] }), _jsx(TabBorderStyled, {})] }));
const TabsContent = TabsPrimitive.Content;
const Tabs = TabsPrimitive.Root;
const TabBorderStyled = styled(TabBorder) `
  position: absolute;
  pointer-events: none;
  opacity: 0;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  z-index: -1000;
`;
const Root = styled(TabsPrimitive.Trigger) `
  color: ${(props) => props.theme.color.gray3};

  position: relative;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  transition: color 300ms ease-in;

  &[data-state='active'] {
    color: ${(props) => props.theme.color.white[100]};
  }

  &[data-state='active'] ${TabBorderStyled} {
    opacity: 1;
  }

  &:hover {
    z-index: 1;
  }
`;
const TabsTriggerValue = styled.span `
  display: flex;
  align-items: center;
`;
const TabsTriggerLabel = styled.span `
  font-size: ${(props) => props.theme.fontSize.m};
  font-weight: ${(props) => props.theme.fontWeight.semibold};

  @media (${(props) => props.theme.mobile.queryMaxWidth}) {
    font-size: ${(props) => props.theme.fontSize.s};
    font-weight: ${(props) => props.theme.fontWeight.bold};
  }
`;
const TabsListWrapper = styled(TabsPrimitive.List) `
  background-image: radial-gradient(
    circle at center,
    ${(props) => props.theme.color.white[25]} 0%,
    transparent 100%
  );
  background-size: 100% 1px;
  background-position: bottom;
  background-repeat: no-repeat;

  display: flex;
  justify-content: space-between;
  text-wrap: nowrap;

  height: 50px;
  width: 100%;

  @media (${(props) => props.theme.mobile.queryMaxWidth}) {
    height: 40px;
  }
`;
//# sourceMappingURL=tabs.js.map